'use strict';

(function ($) {

    $.widget('ui.agMultiLangText', {

        _create: function () {

            var hidden = this.element.find('[jsoncontainer="true"]');

            this._parseJson(hidden.val(), this.element);

            this._on(this.element, {
                'input #MultiLangInput': function (event) {

                    var userdefaultlanguage = this.element.attr('userdefaultlanguage');
                    var target = $(event.target);

                    this.element.find('[langid="' + userdefaultlanguage + '"]').val(target.val());

                    this._createJson();

                    this._trigger("textChanged", null, null);
                }
            });

            this._on(this.element, {
                'input input[inputttype="multilangchild"]': function (event) {

                    var target = $(event.target);
                    var userdefaultlanguage = this.element.attr('userdefaultlanguage');

                    if (target.attr('langid') == userdefaultlanguage) {
                        this.element.find('#MultiLangInput').val(target.val());
                    }

                    this._createJson();

                    this._trigger("textChanged", null, null);
                }
            });

            // To detect changes on form, languages must be always in save order.
            hidden.val(JSON.stringify(this._getJson()));

            // init the agField and change event
            this.element.closest('div.ag-field')
                .agField({
                    getValue: function () {
                        var val = this.getJson();

                        return val;
                    }
                });

        },

        _parseJson: function (json, container) {
            if(json){
                var par = {};
                par = JSON.parse(json);

                this.setJson(par);
            }
        },

        _createJson: function()
        {
            var langs = this._getJson();

            var hidden = this.element.find('[jsoncontainer="true"]');
            hidden.val(JSON.stringify(langs));
            if (event.target.value !== event.target.defaultValue) {
                this.element.closest('div.ag-field').trigger('change.ag.field');
                this.element.closest('div.ag-field').trigger('change_ag_field');
            }
        },

        setJson: function (json) {

            if(json){
                var container = this.element;

                Object.keys(json).forEach(function (key, index) {
                    container.find('[langid=' + key + ']').val(json[key]);
                });
            }
        },

        _getJson: function () {

            var container = this;
            var jsonDocument = {};

            this.element.find('[inputttype="multilangchild"]').each(function (index, val) {
                var $val = $(val);
                jsonDocument[$val.attr('langid')] = $val.val();
            });
            return jsonDocument;
        },

        getJson: function () {
            var container = this;
            var jsonDocument = {};
            var hasValue = false;

            this.element.find('[inputttype="multilangchild"]').each(function (index, val) {
                var $val = $(val);
                jsonDocument[$val.attr('langid')] = $val.val();

                if ($val.val())
                    hasValue = true;
            });
            return hasValue ? jsonDocument : null;
        },

        getValueForUserDefaultLanguage: function () {
            var userdefaultlanguage = this.element.attr('userdefaultlanguage');
            var elementDefaultValue = this.element.find('[langid="' + userdefaultlanguage + '"]').val();
            return elementDefaultValue;
        }

    });
})($);